import { render } from "./PlanosViewPro.vue?vue&type=template&id=1b1d7453&scoped=true"
import script from "./PlanosViewPro.vue?vue&type=script&lang=js"
export * from "./PlanosViewPro.vue?vue&type=script&lang=js"

import "./PlanosViewPro.vue?vue&type=style&index=0&id=1b1d7453&scoped=true&lang=css"
import "./PlanosViewPro.vue?vue&type=style&index=1&id=1b1d7453&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1d7453"]])

export default __exports__